import { render, staticRenderFns } from "./ECShaclLevel.vue?vue&type=template&id=4bd905bb&scoped=true&"
import script from "./ECShaclLevel.vue?vue&type=script&lang=js&"
export * from "./ECShaclLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd905bb",
  null
  
)

export default component.exports